import { useState } from 'react';
import { faqItems } from '@/mocks/articles';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            常见问题
          </h2>
          <p className="text-foreground-600 mt-2 text-sm">从业者最关心的合规运营问题解答</p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl border border-background-200 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 text-left hover:bg-background-100/50 transition-colors duration-200"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {item.question}
                </span>
                <i
                  className={`flex-shrink-0 text-foreground-500 transition-transform duration-300 text-lg ${
                    openIndex === index ? 'ri-subtract-line rotate-180' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-5">
                  <div className="pt-1 border-t border-background-200">
                    <p className="text-sm text-foreground-700 leading-relaxed mt-4">
                      {item.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}